import { Route, Routes } from 'react-router';
import CustomViewContainer from 'src/components/commons/customViewContainer';
import NotFoundPage from 'src/components/commons/notFound';

const OpportunitiesRoutes = () => (
  <Routes>
    <Route index element={<CustomViewContainer>opportunities table</CustomViewContainer>} />
    <Route path='*' element={<NotFoundPage />} />
  </Routes>
);

export default OpportunitiesRoutes;
